import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { SERVICES_TO_REGIONS } from "@/game-lol/constants/constants.mjs";
import * as GraphQLTemplates from "@/game-lol/graphql-templates.mjs";
import LoLSummoner from "@/game-lol/models/lol-summoner.mjs";
import { getDerivedId } from "@/game-lol/utils/util.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function getProfile({
  region,
  gameName,
  tagLine,
}: {
  region: string;
  gameName: string;
  tagLine: string;
}) {
  if (!region || !SERVICES_TO_REGIONS[region.toLowerCase()]) return null;

  const variables = {
    region: region.toUpperCase(),
    gameName,
    tagLine,
  };

  return queryGQL(appURLs.RIOT, GraphQLTemplates.LeagueProfile, variables);
}

export default function ({
  region,
  gameName,
  tagLine,
  path,
  options = {},
}: {
  region: string;
  gameName: string;
  tagLine: string;
  path?: string[];
  options: object;
}) {
  if (!gameName || !tagLine) return Promise.resolve();
  return getData(
    getProfile({ region, gameName, tagLine }),
    LoLSummoner,
    path || ["lol", "profiles", getDerivedId(region, null, gameName, tagLine)],
    {
      skipSafetyCheck: true,
      ...options,
    },
  );
}
